<template>
    <el-header class="app-header">
        <el-row type="flex" justify="space-between" class="h-100 items-center">
            <slot name="left">
                <el-col :span="7" class="text-left">
                    <div @click="goHomePage" v-if="Logo" class="logo">
                        <Logo/>
                    </div>
                    <!--todo 返回上一頁-->
                    <el-button v-if="Back" type="text" @click="goBack()" class="back"/>
                    <!--todo 返回上一頁-->
                    <el-button v-if="BackTo" type="text" @click="goBackToFunc" class="closed"/>
                    <!--todo 關閉-->
                    <el-button v-if="Close" type="text" @click="goBack()" class="closed"/>
                    <!--todo 刪除所有餐點-->
                    <el-button v-if="Delete" type="text"  @click="deleteClick()" class="delete"/>
                </el-col>
            </slot>
            <slot name="center">
                <el-col :span="10" class="text-center" v-if="!Order">
                    <!--todo 搜尋-另開一頁-->
                    <div @click="$router.push({name: 'Search'})"  v-if="Search" class="search-box">
                        <div class="search-text">{{ searchText }}</div>
                        <el-button type="text" class="filter" v-if="Filter"><span/></el-button>
                    </div>
                    <!--todo 搜尋-開彈框-->
                    <div v-else-if="SearchPop" class="search-box" @click="isSearchPop(true)">
                        <div class="search-text">{{ ($public.notNull(searchText) && searchText!=='')? searchText: textOnSearchEmpty }}</div>
                        <el-button type="text" class="filter" v-if="Filter"><span/></el-button>
                    </div>
                    <div v-else class="title">
                        {{title}}
                        <span v-if="name!==''" class="name">{{name}}</span>
                        <span v-if="location!==''" class="location" :areaType="areaType">{{location}}</span>
                    </div>
                </el-col>
            </slot>
            <slot name="right">
                <el-col :span="7" class="text-right" v-if="!Order">
                    <!--todo 品牌牆-->
                    <el-button v-if="Brand" @click="$router.push({name: 'BrandWall'})" type="text" class="brand"/>
                    <!--todo 通知-->
                    <el-button type="text" v-if="Bell" class="bell" @click="goNotify()"/>
                </el-col>
                <!--todo 線上點餐用-->
                <el-col :span="19" class="text-right" v-if="Order">
                    <!--todo 線上點餐訂單-->
                    <el-button type="text" @click="orderClick()" class="order">
                        <!--todo 有正在進行的訂餐時紅點提示-->
                        <div v-if="hasPrepare" class="dot"/>
                    </el-button>
                </el-col>
            </slot>
        </el-row>
        <!--TODO 搜尋彈窗頁面-->
        <div class="fixed-search-pop" v-if="showSearchPop">
            <div class="fixed-pop-content">
                <form action="javascript:return true" class="search-box" :style="{backgroundImage: 'url('+icon+')'}">
                    <el-input
                            placeholder="請輸入搜尋"
                            :trigger-on-focus="false"
                            class="search-input"
                            v-model="input"
                            type="search"
                            ref="search"
                            @keyup.enter.native="handleClick"
                            @clear="handleClear"
                            clearable/>
                </form>

            </div>
            <div class="fixed-pop-closed" @click="isSearchPop(false)"/>
        </div>
        
    </el-header>
</template>

<script>
    import * as constDefine from "@/store/constDefine";
    import Logo from "@/components/Logo";
    export default {
        name: "NavigationBar",
        props: {
            //Left: Boolean,//左邊
            //Right: Boolean,//右邊
            Search: Boolean,//搜尋-另開一頁
            SearchPop: Boolean,//搜尋-開彈窗
            icon:{default: ''},//搜尋-開彈窗的icon
            Brand: Boolean,//品牌
            Bell: Boolean,//提醒鈴鐺
            Back: Boolean,//返回
            BackTo: Boolean,//返回至
            Close: Boolean,//關閉
            Logo: Boolean,//logo
            Order: Boolean,//線上點餐
            //主題活動返回活動列表
            ActivityBack: Boolean,
            //標題
            name:{default: ''},
            //地點分類
            location:{default: ''},
            //主辦方類型 0:其他 1:串門子 2:商圈 3:夜市 4:市集 5:店家
            areaType:{type:Number, default: 0},

            storeId:{require:false,type:Number,default:0},//店家id
            searchText:{},//搜尋內的文字
            textOnSearchEmpty: { default: ''},      //當搜尋爲空白時，要顯示的文字
            Filter: Boolean,//進階篩選

            goBackToFunc: {default: function () {}}, //返回至function

            params: {default: () => {return{}}}, //活用的參數
            Delete: Boolean,//刪除
            isCheckBack: Boolean, //是否檢查有確定回到上一頁
        },
        components: {
            Logo,
        },
        computed: {
            title() {
                return this.$route.meta.title;
            },
            /*flexType: {
                get: function () {
                    //css flex區塊
                    if (this.Right && this.Left) {
                        return 'center'
                    }
                    if (this.Left) {
                        return 'start'
                    }
                    if (this.Right) {
                        return 'end'
                    }
                    return 'space-between'
                }
            }*/
        },
        data() {
            return {
                //是否有準備中訂單
                hasPrepare:false,
                //搜尋彈窗
                showSearchPop:false,
                input:'',
                isGoBack: false,
            }
        },
        created() {

        },
        mounted() {

        },
        destroyed() {
            this.isGoBack = false
        },
        methods: {
            goBack() {
                this.isGoBack = true;
                this.$router.go(-1);

                if(this.isCheckBack) {
                    setTimeout(() => {
                        if(this.isGoBack) {
                            this.$router.go(-1);
                        }
                    })
                }
            },
            goHomePage() {
              this.$router.push({name: 'Home'});
            },
            /** input鍵盤監聽 */
            handleClick(){
                this.showSearchPop = false
                this.$emit(`searchWord`, this.input);
            },
            /**  */
            handleClear(){
                this.$emit(`searchWord`, this.input);
            },

            //開關搜尋彈窗
            isSearchPop(type){
                this.showSearchPop = type
                // this.$emit(`searchWord`, this.input);
                if(type===true){
                    //處理完後開啟focus才有效果
                    this.$nextTick(function () {
                        this.$refs.search.focus();
                    })
                }
            },
            orderClick() {
                if(this.params.usedType === constDefine.QRCodeUsedType.TableOrderAddItem && this.params.orderId > 0) {
                    let dataObject = this.params
                    this.$router.push({path: dataObject.tableOrderRoutePath + "/record"});
                } else {
                    this.$router.push({name: 'OrderRecordList', query: {storeId: this.storeId}})
                }
            },
            isShowOrderBtn() {
                return (this.params.usedType === constDefine.QRCodeUsedType.TableOrderAddItem && this.params.orderId > 0);
            },
            deleteClick() {
                if(this.params.usedType === constDefine.QRCodeUsedType.TableOrderAddItem && this.params.orderId > 0) {
                    this.$emit('triggerEvent', {
                        event: 'clearCart',
                    })
                }
            },
            goNotify() {
                this.$store.commit("saveNotifyPageSnapshot", 'delete');
                this.$router.push({name: 'Notify'})
            }
        },
        watch:{
            '$store.state.orderRecordPrepareCount':function (newVal,oldVal) {
                if (newVal>0) {
                    this.hasPrepare = true;
                }else{
                    this.hasPrepare = false;
                }
            },
        },
    }
</script>

<style lang="less" scoped>

</style>